import { z } from 'zod';
import { businessProfileFieldsSchema } from './business-profile';
import { calendarDateSchema, normalizedUuidSchema as uuidSchema } from './common';

const timestampSchema = z.iso.datetime();
const wonSchema = z.number().int().nonnegative();

export const TAX_INVOICE_KINDS = ['ISSUE', 'CANCEL'] as const;
export type TaxInvoiceKind = (typeof TAX_INVOICE_KINDS)[number];

export const TAX_INVOICE_STATUSES = ['PENDING', 'ISSUED', 'FAILED', 'VOID'] as const;
export type TaxInvoiceStatus = (typeof TAX_INVOICE_STATUSES)[number];

/** 고객·주문 화면에 보이는 상태 — 요청 자체가 없으면 NONE. */
export const TAX_INVOICE_VIEW_STATUSES = [
  'NONE',
  'PENDING',
  'ISSUED',
  'FAILED',
  'CANCELED',
] as const;
export type TaxInvoiceViewStatus = (typeof TAX_INVOICE_VIEW_STATUSES)[number];

export const MAX_TAX_INVOICE_FAILURE_MESSAGE_LENGTH = 200;

export const taxInvoiceViewSchema = z.strictObject({
  status: z.enum(TAX_INVOICE_VIEW_STATUSES),
  ntsConfirmNum: z.string().nullable(),
  issuedAt: timestampSchema.nullable(),
  canceledAt: timestampSchema.nullable(),
});
export type TaxInvoiceView = z.infer<typeof taxInvoiceViewSchema>;

export const adminTaxInvoiceRecordSchema = z.strictObject({
  id: uuidSchema,
  kind: z.enum(TAX_INVOICE_KINDS),
  status: z.enum(TAX_INVOICE_STATUSES),
  mgtKey: z.string(),
  writeDate: calendarDateSchema,
  supplyAmount: wonSchema,
  vatAmount: wonSchema,
  totalAmount: wonSchema,
  ntsConfirmNum: z.string().nullable(),
  issuedAt: timestampSchema.nullable(),
  attempts: z.number().int().nonnegative(),
  failureMessage: z.string().max(MAX_TAX_INVOICE_FAILURE_MESSAGE_LENGTH).nullable(),
  lastAttemptAt: timestampSchema.nullable(),
  createdAt: timestampSchema,
});
export type AdminTaxInvoiceRecord = z.infer<typeof adminTaxInvoiceRecordSchema>;

/** 운영자용 — 주문에 남긴 세금계산서 요청 정보와 발행·취소 기록 전체. */
export const adminTaxInvoiceSchema = z.strictObject({
  request: businessProfileFieldsSchema.nullable(),
  records: z.array(adminTaxInvoiceRecordSchema),
});
export type AdminTaxInvoice = z.infer<typeof adminTaxInvoiceSchema>;

export const reissueTaxInvoiceInputSchema = z.strictObject({ orderId: uuidSchema });
export type ReissueTaxInvoiceInput = z.infer<typeof reissueTaxInvoiceInputSchema>;

export const TAX_INVOICE_ERROR_CODES = [
  'TAX_INVOICE_NOT_FAILED',
  'TAX_INVOICE_NOT_REQUESTED',
  'TAX_INVOICE_ADAPTER_DISABLED',
] as const;
export type TaxInvoiceErrorCode = (typeof TAX_INVOICE_ERROR_CODES)[number];
